module.exports = __webpack_public_path__ + "img/10.12920e6c.jpg";